'use client'
import React, { ReactElement } from 'react'

export interface FilterItemProps {
    width?: 'small' | 'medium' | 'large' | 'unset'
    children: React.ReactNode
}

export const FilterItem = ({ width = 'medium', children }: FilterItemProps): ReactElement => {
    let widthClass = 'w-52'
    switch (width) {
        case 'small':
            widthClass = 'w-40'
            break
        case 'medium':
            widthClass = 'w-52'
            break
        case 'large':
            widthClass = 'w-64'
            break
        case 'unset':
            widthClass = ''
            break
    }

    return <div className={widthClass}>{children}</div>
}
